import { DefaultSeo as NextSeo, OrganizationJsonLd } from 'next-seo';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

export function DefaultSeo() {
  const router = useRouter();

  // strip the query string params for the canonical url
  const pathWithoutQuery = useMemo(
    () => router.asPath.split('?')[0],
    [router.asPath],
  );

  return (
    <>
      <NextSeo
        title="Browse software deals for your business."
        titleTemplate="%s | AppSumo"
        description="Top software deals for entrepreneurs at incredible prices. Discover the latest productivity, marketing, and content tools for your business with no monthly fees."
        twitter={{
          handle: '@appsumo',
          site: '@appsumo',
          cardType: 'summary_large_image',
        }}
        openGraph={{
          type: 'website',
          siteName: 'AppSumo',
          images: [
            {
              url: 'https://appsumo2-cdn.appsumo.com/static/images/meta/appsumo-logo-meta.png',
              alt: 'AppSumo',
            },
          ],
          url: router.asPath,
        }}
        canonical={pathWithoutQuery}
      />
      <OrganizationJsonLd
        name="AppSumo"
        url="https://appsumo.com"
        logo="https://appsumo2nuxt-cdn.appsumo.com/as-appsumo-logo-dark.svg"
        sameAs={[
          'https://twitter.com/AppSumo',
          'https://www.instagram.com/appsumo/',
          'https://www.facebook.com/appsumo/',
          'https://www.youtube.com/channel/UCRrAZbOmqB3pX7dWHC_-wEQ',
          'https://www.tiktok.com/@appsumo',
        ]}
      />
    </>
  );
}
